import { IS_NATIVE_APP } from "../config/appTarget.js";

const GA_ID = "G-917NK5JB1Q";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/** Web-only analytics — skipped on native apps per PRD. */
export function loadGoogleAnalyticsWebOnly(): void {
  if (IS_NATIVE_APP || typeof window === "undefined") return;
  if (document.getElementById("pawseum-gtag")) return;

  const script = document.createElement("script");
  script.id = "pawseum-gtag";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer?.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
  });
}
